import { render } from "./TwoTextColumnsImageBackground.vue?vue&type=template&id=4752d614&scoped=true"
import script from "./TwoTextColumnsImageBackground.vue?vue&type=script&lang=js"
export * from "./TwoTextColumnsImageBackground.vue?vue&type=script&lang=js"

import "./TwoTextColumnsImageBackground.vue?vue&type=style&index=0&id=4752d614&scoped=true&lang=css"

import exportComponent from "/home/richard/Code/CHE/project/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4752d614"]])

export default __exports__